const axios = require("axios");
const urlPrefix = process.env.VUE_APP_ROOT_API_URL;



async function postReq(url,data,callback){
  await axios
  .post(url, {
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data: data
  }).then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}



function createAccount(data, callback){
  let url = urlPrefix + "/user/createAccount";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: data
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}

function updateLastRead(mainID, messageID,callback){
  let url = urlPrefix + "/messages/updateLastRead";
  axios
  .post(url, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: {
      mainID : mainID,
      messageID : messageID
    }
  })
  .then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}

function replyMessage(data,callback){
  let url = urlPrefix + "/messages/replyMessage";
  axios
  .post(url, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: data
  })
  .then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}

function uploadFile(data,callback){
  let url = urlPrefix + "/message/uploadFile";
  axios
  .post(url, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: data
  })
  .then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}

function getMessage(callback){
  let url = urlPrefix + "/messages/getUserMessages";
  axios
  .post(url, {
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: {}
  })
  .then((response) => {
    return callback(response);
  })
  .catch((error) => {
    return callback(error);
  });
}

function stripePayment(stripe, card, email, plan, callback) {
  let url = urlPrefix + "/payment/stripePayment";
  stripe
    .createToken(card)
    .then((result) => {
      axios
        .post(url, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          data: {
            stripeToken: result.token.id,
            plan: plan,
            email: email
          }
        })
        .then((response) => {
          return callback(response);
        })
        .catch((error) => {
          return callback(error);
        });
  });
}

function activateAccount(actCode, callback) {
  let url = urlPrefix + "/payment/activate";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        activationCode: actCode
      }
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}

function editFamilyHistory(body, callback) {
  let url = urlPrefix + "/user/editfamilyhistory";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        familyHistory: body
      }
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}

function editHealthHistory(body, callback) {
  let url = urlPrefix + "/user/editHealthHistory";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        health: body
      }
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}

function updateStep(step, complete, callback) {
  let url = urlPrefix + "/user/updateStep";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        step: step,
        complete: complete
      }
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}

function flagSwitch(flag, callback) {
  let url = urlPrefix + "/user/reviewSwitch";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        flag: flag
      }
    })
    .then((response) => {
      return callback(response);
    })
    .catch((error) => {
      return callback(error);
    });
}


function sendNewMessage(message,callback){
  let url = urlPrefix + "/user/messages/sendMessages";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        message: message
      }
    })
    .then(response => {
      return callback(response);
    })
    .catch(response => {
      return callback(response);
    });
}

function editUserData(userInfo, callback) {
  let url = urlPrefix + "/user/editUserData";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        info: userInfo
      }
    })
    .then(response => {
      return callback(response);
    })
    .catch(response => {
      return callback(response);
    });
}

function resetPassword(options, callback) {
  let url = urlPrefix + "/user/resetPassword";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        options: options
      }
    })
    .then(response => {
      return callback(response);
    })
    .catch(response => {
      return callback(response);
    });
}

function deleteAccount(options, callback) {
  let url = urlPrefix + "/user/deleteAccount";
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: {
        options: options
      }
    })
    .then(response => {
      return callback(response);
    })
    .catch(response => {
      return callback(response);
    });
}

function getUserData(token, callback) {
  let url = urlPrefix + '/user/getUserData';
  axios
    .post(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    })
    .then(response => {
      return callback(response);
    })
    .catch((response) => {
      return callback(response);
    });
}

export {
  createAccount,
  activateAccount,
  deleteAccount,
  editFamilyHistory,
  editHealthHistory,
  editUserData,
  flagSwitch,
  getMessage,
  getUserData,
  resetPassword,
  stripePayment,
  updateLastRead,
  updateStep,
  sendNewMessage,
  replyMessage,
  uploadFile,
  postReq
};
